import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ changeLanguage, currentLang }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const isRtl = t('dir') === 'rtl';

    // Close dropdown on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Map language codes to labels
    const languages = [
        { code: "ar", label: "العربية", },//icon: "🇸🇦" },
        { code: "en", label: "English", },// icon: "🇺🇸" },
        { code: "he", label: "עברית", }//icon: "🇮🇱" },
    ];

    const selectedLang = languages.find((l) => l.code === currentLang);
    const sideDir = isRtl ? 'left-0' : 'right-0';
    return (
        <div dir={t('dir')} className="relative inline-block text-left" ref={dropdownRef}>
            <button
                type="button"
                className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                onClick={() => setOpen(!open)}
                aria-haspopup="true"
                aria-expanded={open}
            >
                <span className="mr-2">{selectedLang?.icon}</span>
                {selectedLang?.label}
                <svg
                    className="ml-2 -mr-1 h-5 w-5 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="5 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>

            {open && (
                <div
                    className={`${"origin-top-right absolute mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"} 
            ${sideDir}`}
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="language-menu"
                >
                    <div className="py-1">
                        {languages.map(({ code, label, icon }) => (
                            <button
                                key={code}
                                onClick={() => {
                                    changeLanguage(code);
                                    setOpen(false);
                                }}
                                className={`flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 ${currentLang === code ? "font-semibold bg-gray-200" : ""
                                    }`}
                                role="menuitem"
                            >
                                <span className="mr-2">{icon}</span>
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
